import { IConfig } from "./Render";
export const Th = ({className, id, children, style, colspan}:IConfig)=>
{
    return (
        <th id={id} className={className} style={style} colSpan={colspan}>{children}</th>
    );
}